import Estimate from "@/usecases/accounting/estimate";
import EstimatePurchaseItem from "./estimate-purchase-item";

export default class EstimatePurchase {
  public estimateId: number = 0;
  public projectId: number = 0;
  public projectName: string = "";
  public title: string = "";
  public taxRate: number = 0;
  public items: EstimatePurchaseItem[] = [];
  public estimateNumber: string = "";

  public constructor(estimate: Estimate = new Estimate()) {
    this.estimateId = estimate.id;
    this.projectId = estimate.projectId;
    this.projectName = estimate.projectName;
    this.title = estimate.title;
    this.taxRate = estimate.taxRate;
    this.items = estimate.items.map(i => new EstimatePurchaseItem(i));
    if (estimate.estimateNumber) {
      this.estimateNumber = estimate.estimateNumber;
    }
  }
}
